export default __webpack_public_path__ + "static/media/Linkedin.91a3feb2.svg";